export const DATAGRID_ID_PREFIX = 'dataGridState__';

export const DATA_TABLE_STATE_PREFIX = 'dataTableState__';
